import { render, staticRenderFns } from "./NewStepupRootComponent.vue?vue&type=template&id=67d61956&scoped=true"
import script from "./NewStepupRootComponent.vue?vue&type=script&lang=js"
export * from "./NewStepupRootComponent.vue?vue&type=script&lang=js"
import style0 from "./NewStepupRootComponent.vue?vue&type=style&index=0&id=67d61956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d61956",
  null
  
)

export default component.exports